// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, useMemo, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_chevron_down
    from '../../../../hola/pub/img/svg/icon/chevron_down.svg';
import Icon_github from '../../img/icons/24/github.svg';
import Icon_linkedin from '../../img/icons/24/linkedin.svg';
import {i_footer_opt, t_route} from '../../types/route';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import styles from './footer.module.less';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';

const r_or_call = (v, default_value?)=>{
    if (v===undefined && default_value!==undefined)
        return default_value;
    if (typeof v=='function')
        return v();
    return v;
};

type t_header_group = {
    header: string;
    header_url?: string;
    togglable: boolean;
    new_tab?: boolean;
    links: {url?: string; text: React.ReactNode;}[];
};

const Copyright = ()=>{
    const {theme} = use_theme();
    const {T} = use_translation_v({no_defaults: true});
    return <div className={cn(styles.content, styles.copyright)}>
      <p className={theme.p14}>&copy; <T>2025 Toolip | All rights reserved</T>
        </p>
    </div>;
};

const Logo = ()=>{
    return <Link className={styles.logo} to="/">
      <img src={toolip_img_url('toolip/logo_black.svg')}/>
    </Link>;
};

const Social_icons = ()=>{
    return <div className={styles.social}>
      <a href="https://www.linkedin.com/company/toolip-io"
        target="_blank"
        rel="noopener
        noreferrer">
        <Icon_linkedin className={styles.linkedin}/>
      </a>
      <a href="https://github.com/sysadmin-toolip"
        target="_blank"
        rel="noopener
        noreferrer">
        <Icon_github className={styles.github}/>
      </a>
    </div>;
};

const Support_text = ()=>{
    const {theme} = use_theme();
    const {T} = use_translation_v({no_defaults: true});
    return <div className={styles.support_text}>
      <p className={theme.p14}>
        <T>Our team is here to help</T> {'♡ '}
        <br/><a href="mailto:support@toolip.io">support@toolip.io</a>
      </p>
    </div>;
};

const Menu_group = ({group}: {group: t_header_group;})=>{
    const [show, set_show] = useState(!group.togglable);
    const {theme} = use_theme();
    const {T} = use_translation_v({no_defaults: true});
    return <div className={cn(styles.group, !show && styles.hidden)}>
      <p className={cn(styles.group_header, theme.P, theme.med,
        group.header_url && styles.group_header_with_url,
        group.togglable && styles.group_header_togglable)}
        onClick={()=>set_show(x=>!x)}
      >
        {!!group.header_url && <a
          href={group.header_url}
          className={cn(theme.p16, theme.med, theme.P, styles.header_url)}
          target={group.new_tab ? '_blank' : undefined}
          rel={group.new_tab ? 'noopener noreferrer' : undefined}>
          <T>{group.header}</T>
        </a>}
        <span className={styles.header_text}><T>{group.header}</T></span>
        {!!group.togglable &&
            <Icon_chevron_down className={styles.arrow}/>}
      </p>
      <div className={styles.elems}>
        {group.links.map(({url, text}, idx)=>
        <p key={url ?? idx}
          className={cn(styles.elem, theme.p14)}>{!url ? <T>{text}</T> :
            <a key={url} href={url} className={cn(theme.P, theme.p14)}
              target={group.new_tab ? '_blank' : undefined}
              rel={group.new_tab ? 'noopener noreferrer' : undefined}>
              <T>{text}</T>
            </a>}
        </p>)}
      </div>
    </div>;
};

interface i_footer_props {
    route: t_route;
}

export const Toolip_footer = (props: i_footer_props)=>{
    const {theme} = use_theme();
    const LINKS: t_header_group[] = useMemo(()=>[{
        header: 'Proxies',
        header_url: '/pricing',
        togglable: true,
        links: [{
            url: get_new_link('/products/dedicated-datacenter'),
            text: 'Dedicated Datacenter Proxies'
        }, {
            url: get_new_link('/products/shared-datacenter'),
            text: 'Shared Datacenter Proxies'
        }, {
            url: get_new_link('/products/isp-proxy?type=isp'),
            text: 'ISP Proxies'
        }, {
            url: get_new_link('/products/residential-proxy'),
            text: 'Rotating Residential Proxies'
        }, {
            url: get_new_link('/products/isp-proxy?type=isp_plus'),
            text: 'Search Engine ISP Proxies'
        }]
        }, {
        header: 'Resources',
        header_url: '//docs.toolip.io/',
        togglable: true,
        new_tab: true,
        links: [{
            url: '//docs.toolip.io/proxy-networks/toolip-proxy-network',
            text: 'Documentation',
        }, {
            url: '/blog',
            text: 'The toolip Blog',
        }, {
            url: '//toolip.postaffiliatepro.com/affiliates/',
            text: 'Affiliate',
        }]
    }, {
        header: 'Legal',
        header_url: '/legal',
        togglable: true,
        links: [{
            url: '/legal/privacy-policy',
            text: 'Privacy Policy'
        }, {
            url: '/legal/terms-conditions',
            text: 'Terms and conditions'
        }, {
            url: '/legal/refund-policy',
            text: 'Refund Policy'
        }, {
            url: '/legal/acceptable-use-policy',
            text: 'Acceptable Use Policy'
        }]
    }], []);
    const {route = {}} = props;
    const {T} = use_translation_v({no_defaults: true});
    const footer_opt: i_footer_opt = r_or_call(route.footer_opt);
    const footer_style = {
        '--footer_gradient_color': footer_opt?.gradient_color,
    } as CSSProperties;
    if (footer_opt?.no_content)
    {
        return <div className={styles.footer} style={footer_style}>
          <div className={styles.wrapper_short}>
            <Logo/>
            <p className={theme.p14}>
              &copy; <T>2025 Toolip | All rights reserved</T>
            </p>
          </div>
        </div>;
    }
    return <div className={styles.footer} style={footer_style}>
      <div className={styles.wrapper}>
        <div className={cn(styles.content, styles.footer_top)}>
          <Logo/>
        </div>
        <div className={cn(styles.content, styles.menu)}>
          <div className={styles.start_group}>
            <Logo/>
            <Support_text/>
            <Social_icons/>
          </div>
          {LINKS.map(group=><Menu_group key={group.header} group={group} />)}
        </div>
        <div className={cn(styles.content, styles.footer_bot)}>
          <Support_text/>
        </div>
        <Copyright/>
      </div>
    </div>;
};
